import { StyleSheet } from "react-native";
import CommonStyles from "../../../../../Diathrive/src/utils/CommonStyles";

const styles = StyleSheet.create({
  container: {
    height: "100vh",
    ...CommonStyles.flex_display,
  },
  previewImage: {
    ...CommonStyles.half_min_width,
    ...CommonStyles.full_flex,
  },
});

export default styles;
